export default __webpack_public_path__ + "static/feelermachine-comp-f4bb97b2b0954597b66517e1e2255027.mp4";